import { createSelector } from 'reselect'
import { pathOr, propOr } from 'ramda'

const getCart = state => state.cart

export const getCheckoutSessionUrl = createSelector(
  getCart,
  propOr('', 'checkoutSessionUrl')
)

export const getPaymentProcessing = createSelector(
  getCart,
  propOr(false, 'paymentProcessing')
)

export const selectCartAvailableBps = createSelector(
  getCart,
  pathOr([], ['cartAvailableBps', 'buildingPassportIds'])
)

export const selectBasketAvailabilityStatus = createSelector(
  getCart,
  propOr('idle', 'basketAvailabilityStatus')
)
